/**
 * @generated SignedSource<<2208ef2bea445cb02e0afc5b95fd3ac2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleContentVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleContentVariant_user";
};
export type HpSharedFeaturedModuleContentVariant_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleContentVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContentVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleContentVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleCarouselVariant_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cd0204727d94c79101b007664989c0b6";

export default node;
